import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.labelElement = this.element.querySelector('[data-btn-label]')
    if (this.labelElement) {
      this.originalText = this.labelElement.innerText || this.labelElement.textContent
    }
  }

  clearTurboFrame() {
    const turboFrame = this.element.closest('turbo-frame')
    if (turboFrame) {
      turboFrame.innerHTML = ''
    }
  }

  async copyUrl() {
    await navigator.clipboard.writeText(this.urlValue)
    this.copyUrlSuccess()
  }

  copyUrlSuccess() {
    if (this.labelElement) {
      const originalText = this.originalText
      this.labelElement.innerText = "URL copied!"
      this.element.style.opacity = "0.5"
      this.element.disabled = true

      setTimeout(() => {
        this.labelElement.innerText = originalText
        this.element.style.opacity = ""
        this.element.disabled = false
      }, 2000)
    }
  }

}
